<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'
import { useLegalAccountDataState } from '../../../../utilities/account/useAccountDataLegal'
import BankAccountsList from '../../common/bankAccounts/BankAccountsList.vue'
import AccountAddEditBankAccountForm from '../../common/bankAccounts/AccountAddEditBankAccountForm.vue'
import EmptyState from '../../../base/EmptyState.vue'

const state = useLegalAccountDataState()

onBeforeMount(() => {
    state.fetchBankAccounts()
})

// Remounts the create form after every save, so it always starts from a clean vee-validate
// state instead of trying to reset a form that just showed validation errors/values.
const createFormKey = ref(0)

function onUpdated() {
    state.fetchBankAccounts()
    createFormKey.value++
}
</script>

<template>
    <div class="grid grid-cols-1 gap-x-4 gap-y-8 px-4 py-5 sm:px-6">
        <div class="overflow-hidden border border-gray-200 bg-white shadow sm:col-span-1 sm:rounded-md">
            <BankAccountsList
                v-if="state.bankAccounts.length > 0"
                :bank-accounts="state.bankAccounts"
                profile-type="legal"
                :profile-uid="state.legalProfile.legal_profile_uid"
                @updated="onUpdated" />
            <EmptyState
                v-else
                classes="my-4"
                :header="$t('bank_account.empty_state_header')"
                :description="$t('bank_account.empty_state_description')" />
        </div>

        <div class="border-t border-gray-200 pt-6">
            <h3 class="text-lg font-bold">
                {{ $t('bank_account.add_bank_account') }}
            </h3>
            <AccountAddEditBankAccountForm
                :key="createFormKey"
                profile-type="legal"
                :profile-uid="state.legalProfile.legal_profile_uid"
                :existing-bank-accounts="state.bankAccounts"
                @saved="onUpdated" />
        </div>
    </div>
</template>
